<script lang="ts" setup>
import { PropType, provide, toRefs } from "vue";

import { type ValidationErrors } from "..";

const props = defineProps({
  validationErrors: {
    type: Object as PropType<ValidationErrors>,
    default: () => ({}),
  },
});

const { validationErrors } = toRefs(props);

/**
 * Resets the validation error at the given path
 * @param path The path of the validation error to reset
 */
const resetValidationError = (path: string) => {
  delete validationErrors.value[path];
};

provide("validationErrors", validationErrors);
provide("resetValidationError", resetValidationError);
</script>

<template>
  <slot />
</template>
